export default __webpack_public_path__ + "static/media/2860.70ceac76.png";